import React, { useState, useEffect } from 'react';
import { NavLink, withRouter, useLocation } from 'react-router-dom';
import moment from 'moment';
import { orderBy } from 'natural-orderby';
import SelfPDFViewer from '../../../../components/PDFViewer';
import AlertService from '../../../../components/SweetAlert';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../config';
import { newFetch, GET, DELETE } from '../../../../helpers/fetch';

const { SERVER_URL } = config;

const EDocs = ({ history }) => {
  const location = useLocation();
  const activeDoc = location.state?.activeDoc;

  const handleDeleteDoc = async (doc_id) => {
    const isConfirmed = await AlertService.confirm(
      '',
      'Are you sure you want to delete this Document?'
    );
    if (isConfirmed) {
      let api_path = `/edoc/${doc_id}`;
      let response = await newFetch(DELETE, api_path);

      if (response.success) {
        ToastUtil.success(response.message);
        history.push('/edocs');
      }
    }
  };

  return (
    <>
      <div
        className="container-fluid"
        style={{ paddingLeft: '2rem', paddingRight: '2rem' }}
      >
        <div className="d-flex mt-4">
          <NavLink
            to={`/edocs`}
            className="text-decoration-none"
            style={{ color: 'inherit' }}
          >
            <div style={{ color: '#A6478E' }}>
              <i className="fas fa-chevron-left pe-2"></i>Back to eDocs
            </div>
          </NavLink>
        </div>
        <div className="pb-2 d-flex align-items-center">
          <h5 className="flex-grow-1 pt-4">eDocs Preview</h5>
        </div>
        <div className="d-flex">
          <div
            className="me-2"
            style={{
              display: 'flex',
              width: '90%',
              flexDirection: 'column',
              justifyContent: 'center',
              border: '#E9E9EF solid 1px',
              backgroundColor: '#E7E7E7',
              paddingTop: 20,
              paddingBottom: 20,
            }}
          >
            {activeDoc?.file && (
              <SelfPDFViewer
                file={`${SERVER_URL}/${activeDoc.file}`}
                withPageNum={false}
              />
            )}
          </div>
          <div className="d-flex flex-column flex-grow-1 ml-4 p-4" style={{width: 530}}>
            <h4>{activeDoc?.title}</h4>
            <div className="d-flex justify-content-between">
              <small>
                Uploaded: {moment(activeDoc?.createdAt).format('DD MMMM YYYY')}
              </small>
              {/* <small>File Size</small> */}
            </div>
            <p className="mt-4" style={{ textAlign: 'justify' }}>
              {activeDoc?.description}
            </p>
            <div>
              <button
                type="button"
                onClick={() => history.push(`/edocs/doc/${activeDoc?.id}/edit`)}
                className="btn btn-outline-brand ml-2 adjust-fs adjust-shadow"
                style={{ width: '8rem', marginRight: '2rem' }}
              >
                Edit
              </button>
              <button
                type="button"
                onClick={() => handleDeleteDoc(activeDoc?.id)}
                className="btn btn-danger adjust-fs adjust-shadow"
                style={{ width: '8rem' }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(EDocs);
